export default __webpack_public_path__ + "static/media/DefaultTokens.3ce0f414.mp4";